export default function isProductAvailable(product) {
  if (!product) return false;
  if (product.listing_product_notAvailable) return false;
  if (!product.listing_stock_amount) return false;

  return product.listing_stock_amount > 0
}
